import { Banner, Modal } from "@shopify/polaris";
import React from "react";

import { updateRemoveAllProductsWarningModal } from "@vendor-app/app/_state/actionCreators/subscriptionDetails";
import { useSmartrrVendorDispatch, useSmartrrVendorSelector } from "@vendor-app/app/_state/typedVendorReduxHooks";

export const RemoveAllProductsModal = ({
  hasPackageProtection,
  onCancel,
  onConfirm,
}: {
  hasPackageProtection: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) => {
  const dispatch = useSmartrrVendorDispatch();
  const closeModal = () => dispatch(updateRemoveAllProductsWarningModal(false));
  const showRemoveAllProductsWarning = useSmartrrVendorSelector(
    state => state.subscriptionDetails.showRemoveAllProductsWarning
  );

  const message = hasPackageProtection
    ? "Removing all products will cancel the entire subscription. Since there will be no products left, package protection will also be removed. Are you sure you wish to continue?"
    : "Removing all items will cancel the entire subscription. Are you sure you wish to continue?";

  return (
    <Modal
      sectioned
      title="Warning"
      open={showRemoveAllProductsWarning}
      onClose={closeModal}
      primaryAction={{
        id: "subscription-details__cancel-remove-all-products-btn",
        content: "Go back",
        onAction() {
          onCancel();
          closeModal();
        },
      }}
      secondaryActions={[
        {
          id: "subscription-details__confirm-remove-all-products-btn",
          content: "Cancel subscription",
          destructive: true,
          onAction() {
            onConfirm();
            closeModal();
          },
        },
      ]}
    >
      <Banner status="critical">{message}</Banner>
    </Modal>
  );
};
